import * as React from 'react';
import { cn } from '../../utils';

const colorMap = {
  pink: 'var(--riso-pink)',
  teal: 'var(--riso-teal)',
  amber: 'var(--riso-amber)',
  blue: 'var(--riso-blue)',
} as const;

interface HalftoneDotProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
  color?: keyof typeof colorMap;
}

const HalftoneDot = React.forwardRef<HTMLDivElement, HalftoneDotProps>(
  ({ size = 200, color = 'pink', className, style, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden
      className={cn('pointer-events-none', className)}
      style={{
        width: size,
        height: size,
        backgroundImage: `radial-gradient(circle, ${colorMap[color]} 1px, transparent 1px)`,
        backgroundSize: '8px 8px',
        borderRadius: '50%',
        ...style,
      }}
      {...props}
    />
  ),
);
HalftoneDot.displayName = 'HalftoneDot';

export { HalftoneDot };
